import React from 'react';
import './tables.css';

export default function PaginationBar({ page, totalPages, onPrev, onNext }) {
  if (totalPages <= 1) return null;
  return (
    <div className="pagination-bar">
      <button onClick={onPrev} disabled={page <= 1}>Prev</button>
      <span>Page {page} / {totalPages}</span>
      <button onClick={onNext} disabled={page >= totalPages}>Next</button>
    </div>
  );
}
